import { render, staticRenderFns } from "./listadoUsuarios.vue?vue&type=template&id=08b72228&"
import script from "./listadoUsuarios.vue?vue&type=script&lang=js&"
export * from "./listadoUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports